export default {
  'audit.overview.pageTitle': 'Finance Audit',
  'audit.overview.pageDescription': 'View statistics of pending finance and property audits',
  'audit.overview.tab.recent30': 'Last 30 Days',
  'audit.overview.tab.allData': 'All Data',
  'audit.overview.dataUpdatedJustNow': 'Data updated: just now',
  'audit.overview.action.refresh': 'Refresh',
  'audit.overview.action.startAudit': 'Start Review',
  'audit.overview.tag.urgent': 'Urgent',
  'audit.overview.tag.normal': 'Normal',
  'audit.overview.metric.pendingCount': 'Pending Count',
  'audit.overview.metric.totalAmount': 'Total Amount Involved',
  'audit.overview.metric.pendingAmount': 'Pending Amount',
  'audit.overview.metric.overdueCount': 'Overdue {count} items',
  'audit.overview.metric.noOverdue': 'No Overdue',
  'audit.overview.card.pendingReceivablesCount.title': 'Pending Receivable Count',
  'audit.overview.card.pendingReceivablesCount.subTitle': 'Current total pending items',
  'audit.overview.card.pendingReceivablesAmount.title': 'Pending Receivable Amount',
  'audit.overview.card.pendingReceivablesAmount.subTitle': 'Platform-wide receivables',
  'audit.overview.card.overdueCount.title': 'Overdue Unpaid Count',
  'audit.overview.card.overdueCount.subTitle': 'High-risk alert',
  'audit.overview.card.overdueAmount.title': 'Overdue Amount',
  'audit.overview.card.overdueAmount.subTitle': 'Bad debt risk stats',
  'audit.overview.section.financeAndApplicationAudit':
    'Finance Expense and Application Review',
  'audit.overview.section.feeAuditMatrix': 'Detailed Fee Audit Matrix',
  'audit.overview.finance.title': 'Finance Pending Audits',
  'audit.overview.property.title': 'Property Pending Audits',
  'audit.overview.total.label': 'Total Pending',
  'audit.overview.total.unit': 'items',
  'audit.overview.feeType.label': 'Fee Type',
  'audit.overview.count.label': 'Pending Count',
  'audit.overview.action.label': 'Action',
  'audit.overview.action.view': 'View Details',
  'audit.overview.action.viewOnly': 'View',
  'audit.overview.empty': 'No pending audits',
  'audit.overview.drawer.title.financialExpense': 'Financial Expense Review',
  'audit.overview.drawer.title.budgetRequest': 'Budget Request Review',
  'audit.overview.drawer.title.mortgageRepayment': 'Mortgage Repayment Review',
  'audit.overview.drawer.title.carRepayment': 'Car Loan Repayment Review',
  'audit.overview.drawer.title.default': 'Finance Review',
  'audit.overview.drawer.tab.reviewLater': 'Review Later',
  'audit.overview.drawer.error.loadStatusStatistics':
    'Failed to load audit status statistics',
  'audit.overview.drawer.message.getDetailFailed':
    'Failed to get document details',
  'audit.overview.drawer.message.unsupportedEdit':
    'Editing is not supported for this type of document',
};
